import React, { useState } from 'react'

import EditSlidePane from './EditSlidePane.jsx'
import ReportEditorContentPane from './ReportEditorContentPane'
import NavigationSidebar from './NavigationSidebar'
import AddSlidePane from './AddSlidePane'

import './AudienceInsightsLayout.scss'
import classNames from 'classnames'

const AudienceInsightsLayout = ({
  audience,
  audienceId,
  slides,
  index,
  categoryOverindex,
  onChangeSlide,
  onFieldChange,
  onChangeSlideOrder,
  onAddSlide,
  onDuplicateSlide,
  onDeleteSlide,
}) => {
  // TODO: improve rerenders for this (better improve render for each slide instead)
  const [isAddingSlide, setIsAddingSlide] = useState(false)

  const handleSwitchAdd = () => setIsAddingSlide((prev) => !prev)

  return (
    <div className="audience-insights-layout">
      <div
        className="audience-insights-layout__edit mac-scrollbar"
        style={{ '--mac-scrollbar-bk': '#fdfdfd' }}
      >
        <EditSlidePane
          slides={slides}
          index={index}
          categoryOverindex={categoryOverindex}
          onFieldChange={onFieldChange}
          audienceId={audienceId}
        />
      </div>
      <div
        className="audience-insights-layout__slides mac-scrollbar"
        style={{ '--mac-scrollbar-bk': '#f4f4f4' }}
      >
        <ReportEditorContentPane
          slides={slides}
          audience={audience}
          index={index}
          onChangeSlide={onChangeSlide}
          onDuplicateSlide={onDuplicateSlide}
          onDeleteSlide={onDeleteSlide}
        />
      </div>
      <div
        className={classNames('audience-insights-layout__add mac-scrollbar', {
          'audience-insights-layout__add--shown': isAddingSlide,
        })}
        style={{ '--mac-scrollbar-bk': '#fafafa' }}
      >
        <AddSlidePane onAddSlide={onAddSlide} />
      </div>
      <div
        className={classNames('audience-insights-layout__nav mac-scrollbar', {
          'audience-insights-layout__nav--add-open': isAddingSlide,
        })}
        style={{ '--mac-scrollbar-bk': '#fdfdfd' }}
      >
        <NavigationSidebar
          activeSlideIndex={index}
          onChangeSlide={onChangeSlide}
          onChangeSlideOrder={onChangeSlideOrder}
          slides={slides}
        />
      </div>
      <div className="audience-insights-layout__switch-add">
        <button onClick={handleSwitchAdd} title={isAddingSlide ? 'Collapse' : 'Add Slide'}>
          <svg
            id="icon"
            className={classNames('ai-icon', {
              open: isAddingSlide,
              close: !isAddingSlide,
            })}
            width="80"
            height="80"
            viewBox="0 0 80 80"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              className="ai-line-1"
              fill="#ffffff"
              width="80"
              height="12"
              x="0"
              y="36"
              ry="4"
              rx="6"
            />
            <rect
              className="ai-line-2"
              fill="#ffffff"
              width="80"
              height="12"
              x="0"
              y="36"
              ry="4"
              rx="6"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default AudienceInsightsLayout
